import React from 'react';
import './ButonInstallAppNav.css';
import useInstallPrompt from '../../../hooks/useInstallPrompt';

const ButonInstallAppNav = () => {
    const { canInstall, installApp } = useInstallPrompt();

    if (!canInstall) {
        return null;
    }

    return (
        <button type='button' onClick={installApp} className='btnInstall'>
            Instalar
        </button>
    );
};

export default ButonInstallAppNav;
